import React from 'react';
import { InputField } from '@prenuvo/halo-web';
import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import { inputClassNames, invalidInputClassNames } from './stripeWrapperClassNames';
import { StripeElementWrapper } from './StripeElementWrapper';
import { isNameValid } from '@/utils/string';
import { useStripeElements } from '@/hooks';

const options = {
  style: {
    base: {
      borderRadius: '0.75rem',
      fontSizeBase: '16px',
      color: '#242424',
      fontWeight: '400',
      fontFamily: 'Lato , sans-serif',
      fontSize: '16px',
      lineHeight: '22.4px',
      '::placeholder': {
        color: '#818181',
      },
    },
    invalid: {
      color: '#242424',
    },
  },
};

export const StripeElements = () => {
  const { cardName, errorsPayment, add, removeError, handleChange, handleStripeElementError } =
    useStripeElements();
  return (
    <div className="flex flex-col">
      <StripeElementWrapper error={errorsPayment?.cardNumber} label="Card Number" name="cardNumber">
        <CardNumberElement
          options={options}
          className={errorsPayment?.cardNumber ? invalidInputClassNames : inputClassNames}
          onChange={({ error, complete }) => {
            if (complete) {
              add({ cardNumberComplete: true });
              removeError('cardNumber');
            }
            handleStripeElementError({ error, field: 'cardNumber', complete });
          }}
        />
      </StripeElementWrapper>
      <div className="grid gap-0 sm:grid-cols-1 sm:gap-6 md:grid-cols-2">
        <StripeElementWrapper
          error={errorsPayment?.cardExpiry}
          label="Expiry Date"
          name="cardExpiry"
        >
          <CardExpiryElement
            options={options}
            className={errorsPayment?.cardExpiry ? invalidInputClassNames : inputClassNames}
            onChange={({ error, complete }) => {
              if (complete) {
                add({ cardExpiryComplete: true });
                removeError('cardExpiry');
              }
              handleStripeElementError({ error, field: 'cardExpiry', complete });
            }}
          />
        </StripeElementWrapper>
        <StripeElementWrapper error={errorsPayment?.cardCvc} label="CVC" name="cardCvc">
          <CardCvcElement
            options={options}
            className={errorsPayment?.cardCvc ? invalidInputClassNames : inputClassNames}
            onChange={({ error, complete }) => {
              if (complete) {
                add({ cardCvcComplete: true });
                removeError('cardCvc');
              }
              handleStripeElementError({ error, field: 'cardCvc', complete });
            }}
          />
        </StripeElementWrapper>
      </div>

      <InputField
        name="cardName"
        label={{ children: 'Name on Card' }}
        placeholder={{ children: 'John Smith' }}
        size="lg"
        type="text"
        variant="outlined"
        maxLength={36}
        onChange={({ target: { value } }) => {
          // the users should be able to delete the name and type it again
          // if the user leaves the field empty, we will show the error message
          if (isNameValid(value) || !value) {
            handleChange(value);
          }
        }}
        isInvalid={!!errorsPayment?.cardName}
        caption={{
          translationKey: errorsPayment?.cardName,
        }}
        value={cardName}
      />
    </div>
  );
};
